/* swiper-guard.js — INP fix (loaded right after swiper-bundle.min.js, before inline sliders init)
   1. Never initialise Swiper twice on the same element (duplicate inline inits / duplicated ids)
   2. Drop MutationObserver-based `observer`/`observeParents` (ResizeObserver, on by default in
      Swiper 11, already handles hidden->visible size changes); update() when a slider becomes visible
   3. Run autoplay only while the slider is actually on screen (sliders in closed menus/offscreen pause) */
(function () {
  var Orig = window.Swiper;
  if (!Orig || Orig.__guarded) return;
  var hasIO = 'IntersectionObserver' in window;
  var io = hasIO ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var s = en.target.swiper;
      if (!s || s.destroyed) return;
      if (en.isIntersecting) {
        try { s.update(); } catch (e) {}
        if (s.__wantsAutoplay && s.autoplay && !s.autoplay.running) { try { s.autoplay.start(); } catch (e) {} }
      } else if (s.__wantsAutoplay && s.autoplay && s.autoplay.running) {
        try { s.autoplay.stop(); } catch (e) {}
      }
    });
  }) : null;

  function toEls(el) {
    if (!el) return [];
    if (typeof el === 'string') { try { return Array.prototype.slice.call(document.querySelectorAll(el)); } catch (e) { return []; } }
    if (el.nodeType === 1) return [el];
    if (el.length !== undefined) return Array.prototype.slice.call(el);
    return [];
  }
  function tune(params) {
    var p = {};
    for (var k in params) if (Object.prototype.hasOwnProperty.call(params, k)) p[k] = params[k];
    p.observer = false;
    p.observeParents = false;
    p.observeSlideChildren = false;
    return p;
  }
  function watch(inst) {
    if (!inst || !inst.el || !io) return inst;
    if (inst.params && inst.params.autoplay && inst.params.autoplay !== false) inst.__wantsAutoplay = true;
    io.observe(inst.el);
    return inst;
  }

  var Guarded = new Proxy(Orig, {
    construct: function (target, args) {
      var a0 = args[0], a1 = args[1], params, elArg;
      if (a1 !== undefined || (a0 && (typeof a0 === 'string' || a0.nodeType === 1))) { elArg = a0; params = a1 || {}; }
      else { params = a0 || {}; elArg = params.el; }
      var els = toEls(elArg);
      if (!els.length) return Reflect.construct(target, args);
      var fresh = els.filter(function (e) { return !e.swiper || e.swiper.destroyed; });
      if (!fresh.length) { // already initialised: hand back the existing instance(s)
        return els.length === 1 ? els[0].swiper : els.map(function (e) { return e.swiper; });
      }
      var p = tune(params);
      var made = fresh.map(function (e) {
        var pe = {}; for (var k in p) pe[k] = p[k];
        pe.el = e; // bind to this exact element (avoids Swiper re-querying a selector)
        return watch(Reflect.construct(target, [pe]));
      });
      return made.length === 1 ? made[0] : made;
    }
  });
  Guarded.__guarded = true;
  window.Swiper = Guarded;
})();
